import React from "react";

const UserDetails = ({ userDetails }) => {
  if (!userDetails) return <p className="text-center">Loading user details...</p>;

  return (
    <div className="mb-7 mt-2">
      <div className="flex justify-between mx-16">
        <div>
          <p className="font-semibold">USER ID</p>
          <p className="font-light pt-2">{userDetails.userId}</p>
        </div>
        <div>
          <p className="font-semibold">EMAIL ID</p>
          <p className="font-light pt-2">{userDetails.email}</p>
        </div>
        <div>
          <p className="font-semibold">CREATE DATE</p>
          <p className="font-light pt-2">{userDetails.createdDate}</p>
        </div>
        <div>
          <p className="font-semibold">ROLE</p>
          <p className="font-light pt-2">{userDetails.role}</p>
        </div>
        <div>
          <p className="font-semibold">GROUP</p>
          <p className="font-light pt-2">{userDetails.group}</p>
        </div>
        <div>
          <p className="font-semibold">ORGANIZATION</p>
          <p className="font-light pt-2">{userDetails.organization}</p>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
